import { ScrollArea } from '@/components/ui/scroll-area';
import { useSidebar } from '@/components/ui/sidebar';
import { useStewardshipStore } from '@/features/stewardship/store/useStewardshipStore';
import { cn } from '@/lib/utils';
import { FC, useEffect, useMemo } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import { StewardshipProjectListSidebar } from './sidebar/StewardshipProjectListSidebar';
import { ProjectFilter } from './ProjectFilter';

export const StewardshipProjectWrapper: FC = () => {
  const [searchParams] = useSearchParams();
  const plant_id = searchParams.get('plant_id');
  const farmer_type = searchParams.get('farmer_type') as string;
  const { employee_id, district_id } = useParams();
  const { open } = useSidebar();
  const {
    responsibleUserProjects,
    responsibleUserProjectsLoading,
    fetchResponsibleUserProjects,
  } = useStewardshipStore();

  const page = useMemo(() => searchParams.get('page') || '1', [searchParams]);
  const size = useMemo(() => searchParams.get('size') || '20', [searchParams]);
  const tax_number = useMemo(
    () => searchParams.get('tax_number') || undefined,
    [searchParams],
  );

  useEffect(() => {
    if (employee_id && plant_id && district_id) {
      fetchResponsibleUserProjects({
        user_id: employee_id,
        plant_id,
        district_id,
        page,
        limit: size,
        tax_number,
        farmer_type,
      });
    }
  }, [employee_id, plant_id, district_id, page, size, tax_number, farmer_type]);

  return (
    <div className="w-full h-[calc(100vh-57px)] overflow-hidden">
      <div className="flex">
        <StewardshipProjectListSidebar
          items={responsibleUserProjects?.content || []}
          isLoading={responsibleUserProjectsLoading}
          totalPages={responsibleUserProjects?.totalPages || 0}
          totalElements={responsibleUserProjects?.totalElements || 0}
        />
        <ScrollArea className="w-full bg-gray-100">
          <ProjectFilter />
          <ScrollArea
            className={cn(
              'h-[calc(100vh-103px)]',
              open ? 'w-[calc(100vw-695px)]' : 'w-[calc(100vw-526px)]',
            )}
          >
            <div className="flex flex-col gap-4 p-8">
              <Outlet />
            </div>
          </ScrollArea>
        </ScrollArea>
      </div>
    </div>
  );
};
